/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
// import Toast from './sub_components/toast';
import * as authServices from '../services/authService';
import * as accountServices from '../services/accountService'
import * as utilService from '../services/utilService'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../configs/const';
// import { ReCAPTCHA_KEY } from '../configs/const';
// import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from './sub_components/maintanence'
import * as constants from '../configs/const'
import Loginb2cHeader from './loginb2cHeader';
import Header from '../components/header'
import Loginb2cFooter from './loginb2cFooter';
import Joinnowpopup from './sub_components/joinnowpopup'
import Loginpopup from './sub_components/loginpopup'
// import bannerList from 'https://images.staticcontents.com/banners/list.json'
import { DOMAINDISPLAY } from '../configs/apkFileName';

let oid = OPERATOR_ID.toLowerCase()
// const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class FAQ extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // uid: "",
            // passcode: "",
            // passVisible: false,
            // rememberMe: false,
            date: "",
            // showToast: false,
            toastMsg: "",
            toastType: "",
            showDownLoad: false,
            inMaitanence: false,
            hasUmShow: true,
            recapchaVal: "",
            isDev: false,
            desktopBanners: {},
            mobileBanners: {},
            operatorDesktopBanners: {},
            operatorMobileBanners: {},
            showPopup: false,
            showLoginPopup: false,
            selectedSection: "",
            clientWidth: document.documentElement.clientWidth,
        };
    }

    formatPickerDate(date) {
        var d = date,
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2)
            month = '0' + month;
        if (day.length < 2)
            day = '0' + day;
        year = year.toString().slice(-2)
        return [year, month, day].join('');
    }



    // onPasswodVisible() {
    //     if (!!this.state.passVisible) {
    //         document.getElementById("passcode").type = "Password"
    //         document.getElementById("passcode-m").type = "Password"
    //     } else {
    //         document.getElementById("passcode").type = "text"
    //         document.getElementById("passcode-m").type = "text"
    //     }
    //     this.setState({ passVisible: !this.state.passVisible })
    // }

    hidePopup(view = "") {
        this.setState({ hasUmShow: false, [`show${view}Popup`]: false })

    }
    showPopup(view = "") {
        // debugger
        this.setState({ [`show${view}Popup`]: true })
    }
    // hideLoginPopup() {
    //     this.setState({ hasUmShow: false, showloginPopup:false })

    // }
    // showLoginPopup() {
    //     this.setState({ showloginPopup: true })
    // }
    togglePopupBetweenLoginSignup(view = "") {
        this.hidePopup(view === "" ? "Login" : "");
        this.showPopup(view);
    }
    toggleSelectedSection(name) {
        this.setState({ selectedSection: this.state.selectedSection === name ? "" : name });
    }
    render() {
        let settings = {
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 5000
        };
        return (
            <div className="radheexch radheexchlogin bg-white-login vsportbg">


                {/* <Loginb2cHeader history={this.props.history}></Loginb2cHeader> */}
                <Header notify={this.props.notify} showSweetAlert={(options) => this.props.showSweetAlert(options)} MySwal={this.props.MySwal} updateHomeData={this.state.updateHomeData} updateHomeDataFalse={() => { this.updateHomeDataFalse() }} subscribe={(type, id) => { this.props.subscribe(type, id) }} subscriptions={this.props.subscriptions} history={this.props.history} socket={this.props.socket} updateSubscribedMarkets={() => { this.updateSubscribedMarkets() }} updateSocket={(skt) => { this.updateSocket(skt) }} getEvtData={(ckt, soc, ten, kbd, elc, hor, hou, bin) => { this.getEvtData(ckt, soc, ten, kbd, elc, hor, hou, bin) }} affCode={this.state.affCode} />
                {/* <div className='login-mar-top100'>
            <section className='sportbook-screen'>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen.jpg"} className="sp-desktop-show" /></a>
                <a onClick={(e) => { this.showPopup("Login") }}><img alt="" src={BASE_IMAGE_PATH + "/casino/banner/loginimages/sportbook-screen-mobile.jpg"} className="sp-mobile-show" /></a>
            </section>
        </div> */}
                <div className='login-mar-top100 bg-black'>
                    <section className='sportbook-faq'>
                        <div>
                            <h2>FAQ</h2>

                            <p className='mt-2'>1) How can I start betting online in India?</p>
                            <p>Learn all basic things about the game you want to wager on before you start betting online in
                                India. Additionally, have a bank account, a way to pay online, and a reliable internet connection.
                                Choose your preferred online bookmaker from the list above, then create an account. After that,
                                start placing wagers on numerous ongoing competitions and events.</p>

                            <p className='mt-2'>2) Is it safe to bet online?</p>
                            <p>India's most reputable and secure online betting site is called {DOMAINDISPLAY.name}. You may always verify their
                                legitimacy by referring to their customer support and agreements, which national and
                                international agencies license</p>

                            <p className='mt-2'>3) Which Indian online betting site is the best?</p>
                            <p>The greatest in this category is the online betting sites we have developed for you in India. These
                                websites all excel in different ways. Let's say you ask us which of the listed online bookmakers in
                                India you should use first before attempting others. In such a situation, {DOMAINDISPLAY.name} is always
                                recommended since it offers a user-friendly interface that will make your first encounter with
                                online betting simple and pleasant.</p>

                            <p className='mt-2'>4) Is it legal to place bets online in India?</p>
                            <p>Online bookmakers are permitted in India. Check the legitimacy of an online betting site to be
                                certain and to lessen the possibility of fraud or other wrongdoing. Ask for their license number if it
                                is not shown on the website, and speak with other platform users to find out about payment
                                status or if they have ever been defrauded there.</p>

                            <p className='mt-2'>5) Conclusion</p>
                            <p>Do not let your sentiments intrude on your ability to win online betting games and tournaments.
                                Play wisely and stake your money on wagers you are certain to win. Do not open numerous
                                betting accounts or place bets you cannot afford to lose. Remember the methods mentioned
                                above and advice when using any betting platform at one of India's top online betting sites. When
                                you start online betting, our betting guide will provide you with all the important information you
                                need to know. It's essential to exercise caution and avoid falling for any shady tactics. The top
                                online bookmakers in India that we have previously identified are reputable, so you may wager
                                on their sporting events without worrying about their integrity.</p>

                        </div>
                    </section>
                </div>


                <Loginb2cFooter history={this.props.history}></Loginb2cFooter>


                {this.state.showPopup && <Joinnowpopup hidePopup={() => { this.hidePopup() }} showSweetAlert={(options) => this.props.showSweetAlert(options)} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} toggleSelectedSection={(name) => { this.toggleSelectedSection(name) }} />}
                {this.state.showLoginPopup && <Loginpopup hidePopup={() => { this.hidePopup("Login") }} showSweetAlert={(options) => this.props.showSweetAlert(options)} history={this.props.history} notify={this.props.notify} togglePopupBetweenLoginSignup={(view) => this.togglePopupBetweenLoginSignup(view)} />}
            </div>)

    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(FAQ);